import type { IconData } from '@stacksjs/iconify-core'

export const tn4x3: IconData = {
  "body": "<path fill=\"#e70013\" d=\"M0 0h640v480H0z\"/><path fill=\"#fff\" d=\"M320 119.2a1 1 0 0 0-1 240.3a1 1 0 0 0 1-240.3M392 293a90 90 0 1 1 0-107a72 72 0 1 0 0 107m-4.7-21.7l-37.4-12.1l-23.1 31.8v-39.3l-37.4-12.2l37.4-12.2V188l23.1 31.8l37.4-12.1l-23.1 31.8z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default tn4x3
